//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import * as React from 'react'
import { ReactElement } from 'react'

const ReinvestIcon = (props: any): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#171717"
      fillRule="evenodd"
      d="M13.994 7.242A6.067 6.067 0 0 0 3.334 4.18v-.848l-.005-.077A.667.667 0 0 0 2 3.333V6l.005.078c.038.331.32.589.662.589h2.666l.078-.005A.667.667 0 0 0 6.001 6l-.005-.078a.667.667 0 0 0-.663-.589H4.127a4.734 4.734 0 0 1 8.546 2.092.667.667 0 0 0 1.32-.183ZM7.41 12.618a4.733 4.733 0 0 1-4.083-4.043.667.667 0 1 0-1.32.184 6.067 6.067 0 0 0 10.66 3.06v.848l.004.078a.667.667 0 0 0 1.33-.078V10l-.005-.078a.667.667 0 0 0-.663-.589h-2.666l-.078.005A.667.667 0 0 0 10 10l.005.078c.038.331.32.589.662.589h1.206a4.734 4.734 0 0 1-4.463 1.95Z"
      clipRule="evenodd"
    />
  </svg>
)
export default ReinvestIcon
